import {
  UserProvidedJobFunction,
  UserTenantAccessLevel,
} from "@gx/ts-contracts/services/database/models/public_pb";
import { UserResource } from "@gx/ts-contracts/services/management/resources/user_pb";

import { getRandomAnimal } from "@/utils/random";

export const USER_TENANT_ACCESS_LEVEL_TO_LABEL_MAP: Record<UserTenantAccessLevel, string> = {
  [UserTenantAccessLevel.UNSPECIFIED]: "—",
  [UserTenantAccessLevel.ADMIN]: "Admin",
  [UserTenantAccessLevel.CREATOR]: "Creator",
  [UserTenantAccessLevel.VIEWER]: "Viewer",
};

export function getUserFirstName(user?: UserResource | null): string {
  if (!user) return "Anonymous";
  return user.firstName;
}

export function getUserLastName(user?: UserResource | null): string {
  if (!user) return getRandomAnimal();
  return user.lastName;
}

export function getUserEmail(user?: UserResource | null): string {
  if (!user) return "—";
  return user.email;
}

export function getUserProvidedJobFunction(user?: UserResource | null): UserProvidedJobFunction {
  if (!user) return UserProvidedJobFunction.UNSPECIFIED;
  return user.currentTenant?.providedJobFunction ?? UserProvidedJobFunction.UNSPECIFIED;
}

/**
 * Get the full name of a user
 * @param user - The user to get the full name of
 * @returns The full name of the user
 */
export function getUserFullName(user?: UserResource | null): string {
  return `${getUserFirstName(user)} ${getUserLastName(user)}`.trim();
}
